import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'countyEmergencyInfoSearchfilter'
})
export class CountyEmergencyInfoSearchfilterPipe implements PipeTransform {
  transform(items: any[], filter: string): any {

    if (!items || !filter) {
      return items;
    }
    items = items.filter(item => item.countyName.toLowerCase().indexOf(filter.toLowerCase()) !== -1 || item.service.toLowerCase().indexOf(filter.toLowerCase()) !== -1 || item.description.toLowerCase().indexOf(filter.toLowerCase()) !== -1);
    return items;
  }

}
